import { setCookie, cookiesConstants } from '@magalu/mixer-utils';
var PAGE_BEFORE_LOGIN = cookiesConstants.PAGE_BEFORE_LOGIN;
var setPageBeforeLogin = function setPageBeforeLogin(page) {
  var _structure$cookies;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  if (structure && !((_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData)) {
    var _structure$config;
    setCookie({
      domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
      name: PAGE_BEFORE_LOGIN,
      value: page
    });
  }
};
export { setPageBeforeLogin };